import LoadingWrapper from "../../../shared/components/LoadingWrapper";
import { ecoColumns, ecoTableCols } from "../../models/vessel-details.const";
import { getEcoSpeedConsumption, togglePerfTableCol } from "../../services/vessel-details.service";
import { PerfManageColsMenu } from "../PerfManageColsMenu";
import { PerfTable } from "./PerfTable";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

// TODO Interface for speed info
export const EcoTable = () => {
  const [isLoading, setLoading] = useState(false);
  const { imoNumber, vesselCode, vesselName } = useParams();
  const [speedInfo, setSpeedInfo] = useState<any[]>([]);

  speedInfo.sort((a, b) => a?.ECO_CONTRACT_VESSEL_SPEED - b?.ECO_CONTRACT_VESSEL_SPEED);
  const speedDataBallast = speedInfo?.filter((user) => user.VESSEL_TYPE === "B");
  const speedDataLaden = speedInfo?.filter((user) => user.VESSEL_TYPE === "L");

  useEffect(() => {
    const speedFetchData = async () => {
      try {
        setLoading(true);
        const speed = await getEcoSpeedConsumption(imoNumber, vesselCode, vesselName);
        setSpeedInfo(speed);
        setLoading(false);
      } catch (error) {
        setLoading(false);
      }
    };

    speedFetchData();
  }, [imoNumber, vesselCode, vesselName, setSpeedInfo]);

  const [visCols, setVisCols] = useState<string[]>(ecoTableCols);
  let ecoCount = ecoColumns.length - visCols.length;

  const BallastMenuButton = PerfManageColsMenu(
    ecoCount,
    ecoColumns,
    visCols,
    togglePerfTableCol(setVisCols),
    "ECO_CONTRACT_VESSEL_SPEED",
  );

  return (
    <LoadingWrapper isLoading={isLoading} loadingIndicatorClassName="text-green" loadingIndicatorSize="lg">
      {PerfTable(
        ecoColumns,
        "ECO_CONTRACT_VESSEL_SPEED",
        visCols,
        speedInfo,
        speedDataBallast,
        speedDataLaden,
        BallastMenuButton,
      )}
    </LoadingWrapper>
  );
};
